import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Warning as WarningIcon } from "@mui/icons-material";
import { Stack, Typography, useTheme } from "@mui/material";
import { TextWithBreaks } from "../text/TextWithBreaks.js";
export const ErrorMessage = ({ message, button }) => {
    const theme = useTheme();
    return (_jsxs(Stack, { flex: 1, direction: "column", spacing: 2, p: 1, justifyContent: "center", alignItems: "center", children: [_jsx(WarningIcon, { color: "secondary" }), _jsx(Typography, { align: "center", children: _jsx(TextWithBreaks, { text: message }) }), button] }));
};
//# sourceMappingURL=ErrorMessage.js.map